export const META_TITLE_REPORT_CREATOR = 'Оценить квартиру онлайн калькулятор недвижимости - Циан';
export const META_TITLE_REPORT = 'Отчет об онлайн оценке недвижимости - Циан';
export const META_TITLE_CALCULATOR = 'Калькулятор недвижимости';
